import { render, staticRenderFns } from "./ProductCategoryIndex.vue?vue&type=template&id=18892dc6&"
import script from "./ProductCategoryIndex.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports